function initCommunitiesGrid(block) {
    if (block.dataset.p7CommunitiesInit) return;
    block.dataset.p7CommunitiesInit = '1';

    const grid = block.querySelector('.p7-communities-grid');
    const loadMore = block.querySelector('.p7-load-more');
    const loading = block.querySelector('.p7-loading');

    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const ajaxurl = block.dataset.ajaxurl;
    const nonce = block.dataset.nonce;

    let page = 1;
    let maxPages = 1;
    let busy = false;

    function load(pageNum = 1) {
        if (busy) return;
        busy = true;

        if (loading) loading.style.display = 'flex';
        if (pageNum === 1) grid.innerHTML = '';

        const body = new URLSearchParams({
            action: 'p7_load_communities',
            nonce,
            page: pageNum,
            attributes: JSON.stringify(attributes)
        });

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) {
                    if (pageNum === 1) {
                        grid.innerHTML = data.data.html;
                    } else {
                        grid.insertAdjacentHTML('beforeend', data.data.html);
                    }

                    page = data.data.current_page;
                    maxPages = data.data.max_pages;
                    loadMore.style.display = page < maxPages ? 'flex' : 'none';
                }
            })
            .finally(() => {
                busy = false;
                if (loading) loading.style.display = 'none';

                if (typeof AOS !== "undefined") {
                    requestAnimationFrame(() => {
                        AOS.refreshHard();
                    });
                }

            });
    }

    if (loadMore) {
        loadMore.addEventListener('click', () => load(page + 1));
    }

    load();
}

document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(m => {
        m.forEach(record => {
            record.addedNodes.forEach(node => {
                if (node instanceof Element) {
                    if (node.classList.contains('p7-communities-grid-block')) {
                        initCommunitiesGrid(node);
                    }
                    node.querySelectorAll('.p7-communities-grid-block').forEach(initCommunitiesGrid);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initialize existing blocks
    document.querySelectorAll('.p7-communities-grid-block').forEach(initCommunitiesGrid);
});
